<template>
  <div class="steps__detail">
    <div class="detail__title">Resumen de servicio</div>
    <div class="detail__section">
      <div class="detail__label">Taller:</div>
      <div class="detail__text">
        {{ order.garage_name || '-' }}
      </div>
    </div>
    <div class="detail__section">
      <div class="detail__label">Dirección:</div>
      <div class="detail__text">
        {{ order.garage_id ? order.garage_full_address : '-' }}
      </div>
    </div>
    <div class="detail__section">
      <div class="detail__label">Horario de atención:</div>
      <div class="detail__text">
        <p v-if="order.garage_id && order.garage_opening_hours">
          {{
            order.garage_opening_hours
              ? `L-V: ${order.garage_opening_hours}`
              : 'L-V: -'
          }}
        </p>
        <p v-if="order.garage_id && order.garage_opening_hours_saturday">
          {{
            order.garage_opening_hours_saturday
              ? `S: ${order.garage_opening_hours_saturday}`
              : 'S: -'
          }}
        </p>
        <p v-if="order.garage_id && order.garage_opening_hours_sunday">
          {{
            order.garage_opening_hours_sunday
              ? `D: ${order.garage_opening_hours_sunday}`
              : 'D: -'
          }}
        </p>
        <p v-else>-</p>
      </div>
    </div>
    <div class="detail__section">
      <div class="detail__label">Vehículo:</div>
      <div class="detail__text">
        {{
          order.vehicle_id
            ? order.vehicle_plate +
              ' / ' +
              order.brand_name +
              ' ' +
              order.model_name +
              ' ' +
              order.version_name
            : '-'
        }}
      </div>
    </div>
    <div class="detail__section">
      <div class="detail__label">Servicio de Mantenimiento Periódico:</div>
      <div class="detail__text">
        {{ order.operation_name || '-' }}
      </div>
    </div>
    <!-- <div class="detail__section">
      <div class="detail__label">Precio:</div>
      <div class="detail__text">
        {{ order.total ? 'S/ ' + order.total : '' }}
      </div>
    </div> -->
    <!-- <div class="detail__section">
      <div class="detail__label">Descripción de problemas o necesidades:</div>
      <div class="detail__text">
        {{ order.other_requirements ? order.other_requirements : '-' }}
      </div>
    </div> -->
    <div class="detail__section">
      <div class="detail__label">Día:</div>
      <div class="detail__text">
        {{
          order.schedule_date
            ? `${scheduleDate[2]}/${scheduleDate[1]}/${scheduleDate[0]}`
            : '-'
        }}
      </div>
    </div>
    <div class="detail__section">
      <div class="detail__label">Hora:</div>
      <div class="detail__text">
        {{ order.schedule_time || '-' }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import { inject, ref, watch, watchEffect } from 'vue'

export default {
  props: {
    url_get_price: {
      type: String,
      default: '',
    },
    url_get_address: {
      type: String,
      default: '',
    },
    url_profile: {
      type: String,
      default: '',
    },
    url_send_mail_for_parts: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const order = inject('order')
    const flag = inject('flag')
    const scheduleDate = ref([])

    const getPrice = async () => {
      if (!order.hasOwnProperty('id')) {
        try {
          const { data } = await axios.request({
            url: props.url_get_price,
            method: 'POST',
            data: {
              garage_id: order.garage_id,
              operation_id: order.operation_id,
              vehicle_id: order.vehicle_id,
            },
          })

          if (data.code?.toString() === '401') {
            Swal.fire({
              icon: 'error',
              title: '¡Ups!',
              text: data.message,
              allowOutsideClick: false,
            })

            order.operation_id = ''

            return false
          }

          order.subtotal = data.subtotal
          order.igv = data.igv
          order.total = data.total
          order.parts_without_price = data.parts_without_price

          if (order.parts_without_price.length > 0 && flag.value == 2) {
            Swal.fire({
              icon: 'warning',
              title: '¡Ups!',
              text: 'El precio del servicio seleccionado no está actualizado en este taller. Nuestro equipo de soporte revisará el caso y le podrá dar una respuesta en un plazo de entre 6 y 24 horas. Desea que lo mantengamos informado?',
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: 'Sí, mantenerme informado.',
              denyButtonText: 'No es necesario, gracias (Salir).',
              allowOutsideClick: false,
            }).then(async (result) => {
              if (result.isConfirmed) {
                order.request_response = true

                Swal.fire({
                  icon: 'warning',
                  text: '¿Desea continuar con la orden?',
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: 'Continuar con la orden',
                  denyButtonText: 'Salir',
                  allowOutsideClick: false,
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    order.operation_flag = false
                    order.operation_name = ''
                    order.subtotal = ''
                    order.igv = ''
                    order.total = ''
                    order.scheduled_appointment = true
                    order.other_requirements_flag = true
                    order.other_requirements = `Solicito información del precio del Servicio de Mantenimiento de ${data.operation_name} de mi vehículo`
                  } else if (result.isDenied) {
                    try {
                      const { data } = await axios.request({
                        url: props.url_send_mail_for_parts,
                        method: 'POST',
                        data: {
                          order: order,
                        },
                      })

                      window.location.href = props.url_profile
                    } catch (error) {
                      console.log(error)
                    }
                  }
                })
              } else if (result.isDenied) {
                try {
                  const { data } = await axios.request({
                    url: props.url_send_mail_for_parts,
                    method: 'POST',
                    data: {
                      order: order,
                    },
                  })

                  window.location.href = props.url_profile
                } catch (error) {
                  console.log(error)
                }
              }
            })
          }
        } catch (error) {
          console.error(error)
        }
      }
    }

    const getAddress = async () => {
      if (!order.hasOwnProperty('id')) {
        try {
          const { data } = await axios.request({
            url: props.url_get_address,
            method: 'POST',
            data: {
              garage_id: order.garage_id,
            },
          })

          order.garage_full_address = data.full_address
          order.garage_opening_hours = data.opening_hours
          order.garage_opening_hours_saturday = data.opening_hours_saturday
          order.garage_opening_hours_sunday = data.opening_hours_sunday
        } catch (error) {
          console.error(error)
        }
      } else {
        const garage_full_address = { ...order.garage_full_address }

        order.garage_full_address = garage_full_address.full_address
        order.garage_opening_hours = garage_full_address.opening_hours
        order.garage_opening_hours_saturday =
          garage_full_address.opening_hours_saturday
        order.garage_opening_hours_sunday =
          garage_full_address.opening_hours_sunday
      }
    }

    // watchEffect(() => {
    //   if (
    //     order.garage_id !== '' &&
    //     order.operation_id !== '' &&
    //     order.vehicle_id !== ''
    //   ) {
    //     getPrice()
    //   } else {
    //     order.subtotal = ''
    //     order.igv = ''
    //     order.total = ''
    //   }
    // })

    watch(
      () => order.operation_id,
      (currentValue, oldValue) => {
        if (currentValue !== '' && currentValue !== oldValue) {
          getPrice()
        } else {
          order.subtotal = ''
          order.igv = ''
          order.total = ''
        }
      }
    )

    watchEffect(() => {
      if (order.garage_id !== '') {
        getAddress()
      } else {
        order.garage_full_address = ''
        order.garage_opening_hours = ''
        order.garage_opening_hours_saturday = ''
        order.garage_opening_hours_sunday = ''
      }
    })

    watchEffect(() => {
      if (order.schedule_date !== '') {
        scheduleDate.value = order.schedule_date.split('-')
      }
    })

    return {
      order,
      scheduleDate,
    }
  },
}
</script>
